




















import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Component({})

export default class LabelValue extends Vue {
    @Prop() public label!: any;
    @Prop() public value!: any;
    @Prop({ default: true }) public inline!: boolean;
    @Prop({default: false}) public specification!: boolean;
    @Prop({ default: false }) public alignRight!: boolean;
}
